<div *ngIf="listaCuentas && listaCuentas.length > 0" class="px-4 sm:px-8 py-4">

  <!-- ═══ TABLA DESKTOP ═══ -->
  <div class="hidden lg:block bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
    <table mat-table [dataSource]="listaCuentas" class="w-full">

      <!-- Nombre -->
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let row">
          <span style="font-weight: 700; font-size: 0.82rem; color: #111827;">{{ row.nombre }}</span>
        </td>
      </ng-container>

      <!-- Tipo -->
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let row">
          <span style="display: inline-flex; align-items: center; gap: 4px; padding: 2px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600;"
            [style.background]="row.esEmpresa ? '#eff6ff' : '#f0fdf4'"
            [style.color]="row.esEmpresa ? '#2563eb' : '#1e5a3f'"
            [style.border]="row.esEmpresa ? '1px solid #bfdbfe' : '1px solid #bbf7d0'">
            <mat-icon style="font-size: 12px; width: 12px; height: 12px; flex-shrink: 0;"
              [style.color]="row.esEmpresa ? '#2563eb' : '#1C593D'">
              {{ row.esEmpresa ? 'business' : 'person' }}
            </mat-icon>
            {{ row.esEmpresa ? 'Empresa' : 'Individuo' }}
          </span>
        </td>
      </ng-container>

      <!-- Banco -->
      <ng-container matColumnDef="banco">
        <th mat-header-cell *matHeaderCellDef>Banco</th>
        <td mat-cell *matCellDef="let row">
          <span style="font-size: 0.82rem; color: #374151;">{{ row.banco?.nombre }}</span>
        </td>
      </ng-container>

      <!-- Identificador -->
      <ng-container matColumnDef="identificador">
        <th mat-header-cell *matHeaderCellDef>Identificador</th>
        <td mat-cell *matCellDef="let row">
          <span style="font-size: 0.82rem; color: #2563eb; font-weight: 600;">{{ row.identificador }}</span>
        </td>
      </ng-container>

      <!-- Nro. Cuenta -->
      <ng-container matColumnDef="numeroCuenta">
        <th mat-header-cell *matHeaderCellDef>Nro. Cuenta</th>
        <td mat-cell *matCellDef="let row">
          <span style="font-size: 0.82rem; color: #374151;">{{ row.numeroCuenta || '—' }}</span>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="acciones" stickyEnd>
        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Acciones</th>
        <td mat-cell *matCellDef="let row">
          <div style="display: flex; gap: 4px; justify-content: center; flex-wrap: wrap;">
            <!-- Ver -->
            <button type="button" title="Ver detalle" (click)="verCuenta(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; transition: all 0.2s;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">visibility</mat-icon>
            </button>
            <!-- Editar -->
            <button type="button" title="Editar" (click)="actualizar(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; transition: all 0.2s;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">edit</mat-icon>
            </button>
            <!-- Eliminar -->
            <button type="button" title="Eliminar" (click)="inactivarCuenta(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer; transition: all 0.2s;"
              onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="seleccionable ? seleccionar(row) : null"
        [style.cursor]="seleccionable ? 'pointer' : 'default'"
        [style.background]="row.seleccionado ? '#f0fdf4' : ''"></tr>
    </table>
  </div>

  <!-- ═══ CARDS MOBILE (colapsables) ═══ -->
  <div class="lg:hidden flex flex-col gap-3">
    <div *ngFor="let cuenta of listaCuentas"
      (click)="seleccionable ? seleccionar(cuenta) : toggleCard(cuenta.id)"
      style="background: white; border-radius: 14px; overflow: hidden; transition: all 0.2s ease;"
      [style.border]="expandedCardId === cuenta.id ? '2px solid #1C593D' : (cuenta.seleccionado ? '2px solid #1C593D' : '1px solid #e5e7eb')"
      [style.box-shadow]="expandedCardId === cuenta.id ? '0 4px 16px rgba(28,89,61,0.1)' : '0 1px 3px rgba(0,0,0,0.06)'">

      <!-- Header siempre visible -->
      <div style="padding: 14px 16px; display: flex; align-items: center; gap: 12px; cursor: pointer;"
        [style.background]="expandedCardId === cuenta.id ? '#f0fdf4' : 'white'">

        <!-- Icono banco -->
        <div style="display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0;"
          [style.background]="cuenta.banco.codigoBanco === 'ZELLE' ? '#fef3c7' : '#eff6ff'">
          <mat-icon style="font-size: 22px; width: 22px; height: 22px; flex-shrink: 0;"
            [style.color]="cuenta.banco.codigoBanco === 'ZELLE' ? '#f59e0b' : '#2563eb'">
            {{ cuenta.banco.codigoBanco === 'ZELLE' ? 'flash_on' : 'account_balance' }}
          </mat-icon>
        </div>

        <!-- Nombre + banco -->
        <div style="min-width: 0; flex: 1;">
          <p style="font-weight: 700; font-size: 0.9rem; color: #111827; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ cuenta.nombre }}
          </p>
          <span style="font-size: 0.78rem; color: #6b7280;">{{ cuenta.banco.nombre }}</span>
        </div>

        <!-- Badge tipo -->
        <span style="display: inline-flex; align-items: center; gap: 3px; background: #f0fdf4; border: 1px solid #bbf7d0; padding: 2px 8px; border-radius: 12px; font-size: 0.65rem; font-weight: 600; color: #1e5a3f; flex-shrink: 0;">
          {{ cuenta.esEmpresa ? 'Empresa' : 'Individuo' }}
        </span>

        <!-- Flecha expandir -->
        <mat-icon style="color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease;"
          [style.transform]="expandedCardId === cuenta.id ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Cuerpo expandible -->
      <div *ngIf="expandedCardId === cuenta.id">
        <!-- Detalles grid 2 cols -->
        <div style="padding: 0 16px 12px; border-top: 1px solid #f3f4f6;">
          <div class="grid grid-cols-2 gap-3" style="padding-top: 12px;">
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Identificador</span>
              <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #2563eb; word-break: break-all;">{{ cuenta.identificador }}</p>
            </div>
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo</span>
              <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ cuenta.esEmpresa ? 'Empresa' : 'Individuo' }}</p>
            </div>
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Banco</span>
              <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ cuenta.banco.nombre }}</p>
            </div>
            <div *ngIf="cuenta.banco.codigoBanco !== 'ZELLE' && cuenta.numeroCuenta">
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Nro. Cuenta</span>
              <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ cuenta.numeroCuenta }}</p>
            </div>
          </div>
        </div>

        <!-- Acciones mobile -->
        <div style="padding: 10px 16px; border-top: 1px solid #f3f4f6; display: flex; gap: 8px;">
          <button type="button" (click)="verCuenta(cuenta); $event.stopPropagation()"
            style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.2s;"
            onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">visibility</mat-icon>
            Ver
          </button>
          <button type="button" (click)="actualizar(cuenta); $event.stopPropagation()"
            style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.2s;"
            onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">edit</mat-icon>
            Editar
          </button>
          <button type="button" (click)="inactivarCuenta(cuenta); $event.stopPropagation()"
            style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.2s;"
            onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">delete</mat-icon>
            Eliminar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
